import * as React from 'react';

export const wrapperStyles = {
    map: {
        height: '500px',
    },
    wrapper: {
        padding: '15px',
        marginTop: '15px',
    },
    buttonContainer: {
        display: 'grid',
        gridAutoFlow: 'column',
        gridGap: '10px',
        gridAutoColumns: 'max-content',
        padding: '10px 0',
    },
    buttons: {
        padding: '15px',
        flex: 1,
    },
    popupStyles: {
        padding: '10px',
        color: 'black',
    },
    searchBoxWrapper: {
        position: 'absolute' as const,
        top: '10px',
        left: '10px',
        zIndex: 1000,
    },
    searchInput: {
        padding: '8px 12px',
        borderRadius: '4px',
        border: '1px solid #ccc',
        width: '220px',
        fontSize: '14px',
    },
    searchSuggestions: {
        background: 'white',
        border: '1px solid #ccc',
        borderRadius: '4px',
        marginTop: '2px',
        maxHeight: '200px',
        overflowY: 'auto' as const,
        boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    },
    searchSuggestionItem: {
        padding: '8px 12px',
        cursor: 'pointer',
        fontSize: '14px',
        color: 'black',
    },
    historyLinkWrapper: {
        marginTop: 6,
    },
    historyLink: {
        cursor: 'pointer',
        color: '#0078d4',
        textDecoration: 'underline',
    } as React.CSSProperties,
};